/* components/AccordionContainer.ts

Standard Accordion Component
Content slides up or down depending on whether it has class 'accordion--open'

Use within liquid as:
{! component 'AccordionContainer', header: 'This is an Example', content: accordionContent, class:'example__class' !}

*/
import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { AccordionHeader } from '@/components/Accordion/AccordionHeader';
import { AccordionBody } from '@/components/Accordion/AccordionBody';
import { cart } from "@/theme/Cart";


@Component
export class AccordionContainer extends ThemeComponent {
    @Ref accordionHeader!: AccordionHeader;
    @Ref accordionBody!: AccordionBody;
    @Ref accordionHeaderText!: HTMLSpanElement;

    @Prop({default: false}) persistState!:boolean;

    init() {
        this.$subscribe(this.accordionHeader.onOpenChange, this.toggleOpen.bind(this));
    }

    private toggleOpen() {
        if (this.classList.contains('accordion--open')) {
            this.close();
        } else {
            this.open();
        }
    }

    public close() {
        this.classList.remove('accordion--open');

        if (this.persistState) {

            this.accordionHeaderText.innerText = 'Show popular categories';

            cart.updateAttributes({
                showPopular: false
            }).catch((error) => {
                this.$log.error('There was an error setting the browsing preference');
            });
        }

    }

    public open() {
        this.classList.add('accordion--open');


        if (this.persistState) {
            this.accordionHeaderText.innerText = 'Hide popular categories';
            cart.updateAttributes({
                showPopular: true
            }).catch((error) => {
                this.$log.error('There was an error setting the browsing preference');
            });
        }
    }
}
